import React from 'react'

import { useSignUp } from '@/components/Providers/SignUpProvider'
import { Button, Text } from '@/components/common'

import SignUpLayout from './SignUpLayout'
import FormBox from './FormBox'

const getMessageId = id => `pages.signUp.form.existingUser.${id}`

const ExistingUser = () => {
  const {
    user,
    handleRedirectToApp,
  } = useSignUp()

  return (
    <SignUpLayout split={false}>
      <FormBox shouldCalculateMargin={false}>
        <Text.P
          center
          ellipsized
          messageProps={{
            id: getMessageId('greeting'),
            values: {
              firstName: user.firstName,
              lastName: user.lastName,
            },
          }}
          noMargin
          size="large"
        />
        <Text.P center messageId={getMessageId('welcomeBack')} noMargin size="small" />
        <Text.P center messageId={getMessageId('existingUserRedirect')} noMargin size="small" />
        <div className="text-center">
          <Button
            messageId={getMessageId('redirectToNeat')}
            onClick={handleRedirectToApp}
            size="xsmall"
            variant="link"
          />
        </div>
      </FormBox>
    </SignUpLayout>
  )
}

export default ExistingUser
